import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/table/table.jsx';
import Loader from '../../components/loader/loader.jsx';
import * as FileSaver from 'file-saver';
import limitService from '../../services/limits_service.js';
import { selectFilter, selectLimits } from '../../state/selectors/limits.js';
import {createStructuredSelector} from 'reselect';
import LimitTableColumns from '../../constants/table/limits_columns.js';
import { useLocalization } from '../../hooks/useLocalization.js';

const mapStateToProps = createStructuredSelector ({    
        limits: selectLimits(),
        filter: selectFilter()
    });

const LimitList = (props) => {
    const { limits, filter } = props;
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {       
        getData();
    }, []);
    
    const {t} = useLocalization();
    
    useEffect(() => {
        const timer = setInterval(async() => {await getDataSilent(filter)}, 5000);

        return () => {
            token.cancel();
            clearInterval(timer);
        }
    }, [filter])

    const token = {cancel: () => {}};

    const getData = async (filterToSelect) => {
        token.cancel();        
        filterToSelect = filterToSelect ? filterToSelect : filter;
        try {
            setLoading(true);
            await limitService.getLimits(filterToSelect, token);  
            setLoading(false);          
        }
        catch (error) {
            setLoading(false);
        }
    }

    const getDataSilent = async (filterToSelect) => {
        token.cancel();        
        filterToSelect = filterToSelect ? filterToSelect : filter;
        try {
            await limitService.getLimits(filterToSelect, token); 
        }
        catch (error) {
        }
    }

    const getReport = () => {
        limitService.getReport(filter).then(data => {
            if (data) {
                FileSaver.saveAs(data, 'limits.xlsx');
            }
        });
    }

    const modelFilter = {
        cardNumber: {
            name: "cardNumberInternal",
            type: "string",
            header: t('Limits.cardNumber'),
            value: filter.modelFilter.cardNumberInternal
        },
        userName: {
            name: "cardOwnerName",
            type: "string",
            header: t('Limits.cardOwnerName'),
            value: filter.modelFilter.cardOwnerName
        },
        fuelType: {
            name: "fuelType",
            type: "string",
            header: t('Limits.fuelType'),
            value: filter.modelFilter.fuelType
        },
        isActive: {
            name: "isActive",
            type: "select",
            header: t('Limits.isEnabled'),
            value: filter.modelFilter.isActive,
            options: [
                {
                    name: t("Limits.activityAllFilter"),
                    value: -1
                },
                {
                    name: t("Limits.onlyActiveFilter"),
                    value: 1
                },
                {
                    name: t("Limits.onlyNotActiveFilter"),
                    value: 0
                }
            ]
        }
    };
    
    return (
        <div>
            <Table settings={{
                columns: LimitTableColumns,
                items: limits,
                itemsFilter: Object.assign({}, filter, { filterProps: modelFilter }),
                isEditable: false,
                getItemsFunction: getData,
                getReportFunction: getReport,
                rowStylePrepare: (limit) =>  {
                    return (limit.totalVolume >= limit.dateLimit) ? {borderColor: 'red', borderWidth: '1px', borderStyle: 'solid', backgroundColor: 'rgba(255, 13, 0, 0.28)'} : undefined}
            }} />
            {loading && <Loader />}
        </div>
    );

}


export default connect(mapStateToProps)(LimitList);